import type { SavedScheduleResult } from '../../../../../apis/campaignGraphqlManager/customPacing/types';
import { mapCustomPacingErrors } from '../utils/errors';
import type { ResultInfoProps } from './ResultInfo/ResultInfo';

export const mapSaveScheduleResultToResultInfoProps = (saveScheduleResult: SavedScheduleResult): ResultInfoProps => {
  return {
    countSuccessItems: saveScheduleResult.summary.successful,
    errorItems: mapCustomPacingErrors(saveScheduleResult.errors),
    reportId: saveScheduleResult.reportId ?? null,
  };
};
